import moment from 'moment'
// import {debounce} from ' lodash'

export function basicInfo(data) {
  const basicInfo = {
    // 'First Name': data.first_name,
    // 'Last Name': data.last_name
    'Date of Birth': moment(data.dob).format('DD-MM-YYYY'),
    'Nationality': data.nationality,
    'Religion': data.religion,
    'Gender': data.gender,
    'Category': data.category,
    'Mother Tongue': data.language,
    'Aadhaar No': data.aadhaar_no,
    'PEN NO': data.pen_no,
    'APAAR ID': data.apaar_id,
    'Bus PickUp Point': data ? (data.transport === 1 ? data.transport_pickup_point : '') : '',
    'Student Type': data.student_type ? data.student_type.name : '',
  }

  return basicInfo
}

export function contactInfo(data) {
  const contactInfo = {
    Address: data.address,
    Landmark: data.landmark,
    Pincode: data.pincode,
    City: data.city,
    State: data.state,
    Country: data.country,
    Phone: data.phone ? data.country_code + '' + data.phone : '',
    'Alt Phone': data.alt_phone
      ? data.alt_country_code + '' + data.alt_phone
      : '',
    Email: data.email,
  }

  return contactInfo
}

export function academicInfo(data, currentSession) {
  const academicInfo = {
    Class: data ? (data.school_class ? data.school_class.name : '') : '',
    Section: data ? (data.section ? data.section.name : '') : '',
    'Roll No': data ? data.roll_no : '',
    Session: currentSession.name,
  }

  return academicInfo
}

// export function electivesInfo(data) {
//   const electivesInfo = {}
//   data.forEach(function(item, index) {
//     let key = item.pivot.elective_subject
//     electivesInfo[key] = item.name
//   })

//   return electivesInfo
// }
export function electivesInfo(data) {
  const electivesInfo = {}

  data.forEach(function (item, index) {
    const key = item.pivot.elective_subject

    if (!electivesInfo[key]) {
      electivesInfo[key] = []
    }

    electivesInfo[key].push(item.name || '—')
  })

  return electivesInfo
}

export function previousSchoolInfo(data) {
  const previousSchoolInfo = {
    'Previous School': data.previous_school_name,
    'Previous Class': data.previous_class,
    'Previous Board': data.previous_board,
    'Previous Score': data ? data.previous_percentage : '',
    'Previous Roll No': data ? data.previous_rollno : '',
    'Previous Total Marks': data ? data.previous_mark : '',
    'Previous  CGPA': data ? data.previous_cgpa : '',
    'No of Days Attended': data ? data.days_attended : '',
    'Previous Exam Type': data ? data.previous_exam_type === 'other' ? (data.previous_exam_other || '—') : (data.previous_exam_type || '—').toUpperCase() : '',
  }

  return previousSchoolInfo
}

export function parentInfo(data) {
  console.log('parentInfo', data)
  const parentInfo = {}
  data.forEach(function (item, index) {
    if (item.relation === 'father' || item.relation === 'mother') {
      let key = item.relation.charAt(0).toUpperCase() + item.relation.slice(1)
      parentInfo[key] = item
    }
  })

  return parentInfo
}

export function medicalInfo(data) {
  const medicalInfo = {
    'Blood Group': data.blood_group,
    Allergies: data.allergies,
    'Major Illness': data.major_illness,
  }

  return medicalInfo
}

// TODO: Need to call api for student type and map the id correspondingly
export function otherInfo(data) {
  const otherInfo = {
    'Sports': data.student_meta ? (data.student_meta.sports === 1 ? 'Yes' : 'No') : '',
    'Orphan': data.student_meta ? data.student_meta.orphaned === 1 ? 'Yes' : 'No' : '',
    'AAY Beneficiary': data.student_meta ? (data.student_meta.aay === 1 ? 'Yes' : 'No') : '',
    'ASD (Autism Spectrum Disorder)': data.student_meta ? (data.student_meta.asd === 1 ? 'Yes' : 'No') : '',
    'EWS (Economically Weaker Section)': data.student_meta ? (data.student_meta.ews === 1 ? 'Yes' : 'No') : '',
    'Internal Displaced Person(IDP)': data.student_meta ? (data.student_meta.student_idp === 1 ? 'Yes' : 'No') : '',
    'Tattoo on any visible part of body': data.student_meta ? (data.student_meta.tattooed === 1 ? 'Yes' : 'No') : '',
    'CWSN (Children with Special Needs)': data.student_meta ? (data.student_meta.cwsn === 1 ? data.student_meta.cwsn_facility : '') : '',
    'Competition Appeared': data.student_meta && (data.student_meta.competition_appeared) === 'Yes' ? data.student_meta.competition_type : '',
    'SLD (Specific Learning Disability)': data.student_meta ? (data.student_meta.sld === 1 ? data.student_meta.sld_facility : '') : '',
    'Gifted and Talented': data.student_meta ? (data.student_meta.gifted === 1 ? 'Yes' : 'No') : '',
    'ADHD (Attention Deficit Hyperactivity Disorder)': data.student_meta ? (data.student_meta.adhd === 1 ? 'Yes' : 'No') : '',
  }
  return otherInfo
}
